import * as ddo from "../constants/customObjConstants";
import * as tag from "../constants/customMetadataConstants";
import * as portalShared from "../shared/metadataConstantsAndUtilities";
import React, {useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import {Paper, List, ListItem, Box} from "@mui/material";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import * as style from "../utilities/getStyle";
import Button from "@mui/material/Button";
import {answerQuestionRanking, answerQuestionTemplateRanking} from "../actions/portalActions";

export const RankingQuestion = ({textEntryType, inputType, itemObj, props}) => {
    const {questionnaire, question, questionNumber, surveyEditMode, displayMode, answerQuestionOptions, answerQuestionTemplateOptions} = props;
    const dispatch = useDispatch();

    //let activeTemplate = question;
    let activeTemplateType = "question";

    let textObj = null;
    if (activeTemplateType === "question") {
        textObj = ddo.getQuestionNameText(question, questionNumber);
    }

    //const [answers, setAnswers] = useState([]);
    const [draggedIndex, setDraggedIndex] = useState(null);
    const [confirmedOrder, setConfirmedOrder] = useState(false);

    let savedObjs = {
        customTemplateObj: null,
        itemObj: itemObj,
        inputType: inputType,
        textEntryType: textEntryType,
        inputModifier: "",
        questionnaire: questionnaire,
        question: question,
        questionNameHidden: (tag.metadataValue(question, portalShared.CUSTOM_DDO_NAME) === "hide"),
        questionNumber: questionNumber === "0" ? "" : questionNumber,
        questionTextObj: textObj,
        answers: ddo.getAnswerOptions(question),
        answerText: "",
        answerQuestionOptions: answerQuestionOptions,
        answerQuestionTemplateOptions: answerQuestionTemplateOptions,
        displayMode: displayMode,
        surveyEditMode: surveyEditMode,
        readonlyMode: (surveyEditMode === portalShared.READONLY_SURVEY),
    }

    if (tag.metadataExists(question, portalShared.CUSTOM_DDO_QUE_FORMAT)) {
        savedObjs.customTemplateObj = tag.metadataValueObj(question, portalShared.CUSTOM_DDO_QUE_FORMAT);
    } else {
        savedObjs.customTemplateObj = portalShared.getCustomQuestionRankingObj(question.questionType);
    }

    const firstAnswerSelected = savedObjs.answers[0]?.selected === true;

    useEffect(() => {
        setConfirmedOrder(firstAnswerSelected);
    }, [firstAnswerSelected]);

    const handleDragStart = (index) => {
        setDraggedIndex(index);
    };

    const handleDragOver = (event) => {
        event.preventDefault();
    };

    const handleDrop = (dropIndex) => {
        if (draggedIndex === null || draggedIndex === dropIndex) {
            return;
        }

        const updatedAnswers = [...savedObjs.answers];
        const draggedItem = updatedAnswers[draggedIndex];
        updatedAnswers.splice(draggedIndex, 1);
        updatedAnswers.splice(dropIndex, 0, draggedItem);
        setDraggedIndex(null);
        setConfirmedOrder(true);

        saveAnswerTypeRanking(savedObjs, updatedAnswers);
    };

    const saveAnswerTypeRanking = (savedObjs, answers) => {
        if (!savedObjs.readonlyMode) {

            // Instant MODE or Template Mode?
            if (savedObjs.displayMode === portalShared.INSTANT_MODE) {
                let answersKeysArray = [];

                for (let i = 0; i < answers.length; i++) {
                    answersKeysArray.push(answers[i].key);
                }
                dispatch(answerQuestionRanking(savedObjs.question.id, answers, {answerRanking: answersKeysArray}));
            } else {
                dispatch(answerQuestionTemplateRanking(savedObjs.question.id, answers));
            }
        }

    }

    const handleConfirmRanking = () => {

        // Save ranking here
        setConfirmedOrder(true);
        saveAnswerTypeRanking(savedObjs, savedObjs.answers);
    };

    let customQuestionObj = savedObjs.customTemplateObj
    let CustomTypographyStyle = style.getCustomTextStyle(customQuestionObj.text);


    return (
            <List
                sx={{alignItems: "center", width: '100%'}}>

                <Paper
                    elevation={3}
                    sx={{
                        padding: 2,
                        backgroundColor: savedObjs.customTemplateObj.paperBackgroundColor.color,
                        // width: `${customQuestionObj.widthEntry}${customQuestionObj.widthType === "percentage" ? '%' : 'px'}`,
                    }}
                >
                    {savedObjs.answers.map((answer, index) =>
                        <ListItem
                            key={answer.key}
                            draggable={!savedObjs.readonlyMode}
                            onDragStart={() => handleDragStart(index)}
                            onDragOver={handleDragOver}
                            onDrop={() => handleDrop(index)}
                            component={Paper}
                            elevation={2}
                            sx={{
                                padding: 2,
                                marginBottom: 1,
                                cursor: savedObjs.readonlyMode ? "default" : "grab",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                userSelect: "none",
                                backgroundColor: customQuestionObj.backgroundColor.color,
                                border: customQuestionObj.borderEnabled ? `${customQuestionObj.borderWidth}px solid ${customQuestionObj.borderColor.color}` : undefined,
                                borderRadius: customQuestionObj.borderEnabled ? `${customQuestionObj.borderRadius}px` : undefined,

                                "&:hover": {
                                    backgroundColor: customQuestionObj.hoverBackground.color,
                                    // boxShadow: 6
                                    border: customQuestionObj.borderEnabled ? `${customQuestionObj.borderHoverWidth}px solid ${customQuestionObj.hoverBorder.color}` : undefined,
                                    borderRadius: customQuestionObj.borderEnabled ? `${customQuestionObj.borderRadius}px` : undefined,

                                    "& .rank-text": {
                                        color: customQuestionObj.hoverText.color
                                    },

                                    "& .rank-number": {
                                        color: customQuestionObj.hoverNumbers.color
                                    },

                                    "& .drag-icon": {
                                        color: customQuestionObj.hoverDragIconColor.color,
                                        opacity: customQuestionObj.showDragIcon ? 1 : 0
                                    }
                                }
                            }}
                        >
                            <Box
                                display="flex"
                                alignItems="center"
                                gap={2}
                            >
                                {customQuestionObj.numbersEnabled ?
                                    <CustomTypographyStyle
                                        className="rank-number"
                                        fontWeight="bold"
                                        sx={{color: customQuestionObj.numbers.colorObj.color}}>
                                        {index + 1}.
                                    </CustomTypographyStyle> : ""
                                }

                                <CustomTypographyStyle
                                    className="rank-text"
                                    sx={{color: customQuestionObj.text.colorObj.color}}>
                                    {answer.optionText}
                                </CustomTypographyStyle>
                            </Box>
                            <DragIndicatorIcon
                                className="drag-icon"
                                sx={{color: customQuestionObj.dragIconColor.color, opacity: customQuestionObj.showDragIcon ? 1 : 0}}/>
                        </ListItem>
                    )}
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            marginTop: "16px"
                        }}
                    >
                        <Button
                            variant="contained"
                            onClick={handleConfirmRanking}
                            disabled={confirmedOrder}
                            sx={{
                                backgroundColor: customQuestionObj.buttonObj.buttonColor.color,
                                color: customQuestionObj.buttonObj.buttonTextColor.color,

                                "&:hover": {
                                    backgroundColor: customQuestionObj.buttonObj.hoverButtonColor.color,
                                    color: customQuestionObj.buttonObj.hoverButtonTextColor.color
                                },

                                fontFamily: customQuestionObj.text.fontFamily,
                            }}
                        >
                            Confirm Ranking
                        </Button>
                    </Box>
                </Paper>
            </List>
    )
}

export default RankingQuestion;
